mutation DocumentPoolSecurity($input: DocumentPoolRowProtectionInput!) {
  documentPoolRowProtection(input: $input) {
    documentPool {
      id
      documentPoolSecureRowLevels {
        id
        name
        description
        securityLevel
      }
    }
  }
}
